/** Short times for the inbox: "3:04 PM" today, "Mon 3:04 PM" this week, "Oct 3" before. */
export function formatWhen(iso: string, now: Date = new Date()): string {
  const at = new Date(iso);
  const sameDay = at.toDateString() === now.toDateString();
  if (sameDay) return at.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  const ageDays = (now.getTime() - at.getTime()) / 86_400_000;
  if (ageDays < 6 && ageDays > -1) {
    return at.toLocaleString(undefined, { weekday: 'short', hour: 'numeric', minute: '2-digit' });
  }
  return at.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/** Full date and time for titles and "held until". */
export function formatFull(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** When an unknown text may be resent: 10 minutes after its last change (the database rule). */
export const UNKNOWN_RESEND_AFTER_MS = 10 * 60_000;

export function resendAvailableAt(updatedAt: string): Date {
  return new Date(new Date(updatedAt).getTime() + UNKNOWN_RESEND_AFTER_MS);
}

/**
 * Inbox row time (brand/components/InboxRow): "now", minutes under an hour ("2m"), clock time today,
 * "Yesterday", then a short date.
 */
export function formatRowTime(iso: string, now: Date = new Date()): string {
  const at = new Date(iso);
  const minutes = Math.floor((now.getTime() - at.getTime()) / 60_000);
  if (minutes >= 0 && minutes < 1) return 'now';
  if (minutes >= 1 && minutes < 60) return `${minutes}m`;
  if (at.toDateString() === now.toDateString()) {
    return at.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  }
  if (at.toDateString() === addDays(now, -1).toDateString()) return 'Yesterday';
  return at.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/** Day separators in a thread: "Today", "Yesterday", then the date. */
export function formatDay(iso: string, now: Date = new Date()): string {
  const at = new Date(iso);
  if (at.toDateString() === now.toDateString()) return 'Today';
  if (at.toDateString() === addDays(now, -1).toDateString()) return 'Yesterday';
  return at.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    ...(at.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }),
  });
}

/** Clock time under a bubble group. */
export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}

function addDays(d: Date, days: number): Date {
  const copy = new Date(d);
  copy.setDate(copy.getDate() + days);
  return copy;
}
